/**
 * ar.ts — القاموس العربي. مفاتيح مسطّحة "namespace.key" تطابق أسماء المكوّنات.
 * كل مفتاح هنا يجب أن يقابله مفتاح بنفس الاسم في en.ts (يفرضه نوع Dictionary).
 */
export const AR_DICTIONARY = {
    // ── عام ─────────────────────────────────────────────────────────────
    'common.language': 'اللغة',
    'common.arabic': 'العربية',
    'common.english': 'الإنجليزية',
    'common.cancel': 'إلغاء',
    'common.confirm': 'تأكيد',
    'common.save': 'حفظ',
    'common.loading': 'جارِ التحميل…',
    'common.close': 'إغلاق',
    'common.retry': 'إعادة المحاولة',
    'common.menu': 'القائمة',
    'common.settings': 'الإعدادات',
    'common.play': 'تشغيل',
    'common.pause': 'إيقاف',
    'common.none': '—',

    // ── أسماء الطبقات (تُشتق من معرّف الطبقة: layer.<id>) ─────────────────
    'layer.wind': 'الرياح',
    'layer.wind-gusts': 'هبّات الرياح',
    'layer.radar-sim': 'رادار متوقَّع',
    'layer.precipitation': 'هطول الأمطار',
    'layer.temperature': 'درجة الحرارة',
    'layer.feels-like': 'الإحساس الحراري',
    'layer.wet-bulb': 'اللمبة الرطبة',
    'layer.k-index': 'مؤشر العواصف',
    'layer.o-index': 'عواصف رعدية',
    'layer.pressure': 'الضغط الجوي',
    'layer.humidity': 'الرطوبة النسبية',
    'layer.dewpoint': 'نقطة الندى',
    'layer.clouds': 'الغيوم',
    'layer.radar': 'رادار الأمطار',
    'layer.satellite': 'قمر صناعي',
    'layer.hurricanes': 'الأعاصير',
    'layer.wildfires': 'الحرائق',

    // تسميات مختصرة داخل قائمة الطبقات (المجموعة الرئيسية ومتغيّراتها)
    'layerGroup.satellite': 'قمر اصطناعي',
    'layerGroup.radar': 'رادار الأمطار',
    'layerGroup.radar-sim': 'رادار متوقَّع (نموذج)',
    'layerGroup.precipitation': 'هطول الأمطار',
    'layerGroup.wind': 'الرياح',
    'layerGroup.temperature': 'درجة الحرارة',
    'layerGroup.k-index': 'مؤشر العواصف',
    'layerGroup.humidity': 'الرطوبة',
    'layerGroup.pressure': 'الضغط',
    'layer.t850-anomaly': 'شذوذ حرارة 850 hPa',
    'layerDesc.t850-anomaly': 'فرق حرارة الجو عند 850 هكتوباسكال (نحو 1.5 كم) عن معدّله المناخي 1981–2010 — يكشف الكتلة الهوائية بعيداً عن ضجيج السطح.',
    'layerGroup.t850-anomaly': 'شذوذ حرارة 850 hPa',
    'layer.sst-anomaly-rel': 'حرارة المحيطات — نسبي',
    'layerDesc.sst-anomaly-rel': 'شذوذ حرارة سطح البحر بعد طرح متوسّط المحيط المداري — يعزل النينيو عن الاحترار العام.',
    'layerVariant.sst-anomaly': 'مطلق',
    'layerVariant.sst-anomaly-rel': 'نسبي',
    'legend.sstAnomalyRel': 'شذوذ حرارة سطح البحر ({unit}) — نسبيّ، بعد طرح متوسّط المداري',
    'layer.sst-anomaly': 'حرارة المحيطات — النينيو',
    'layerDesc.sst-anomaly': 'فرق حرارة سطح البحر عن معدّله المناخي (1971–2000). الأحمر أدفأ من المعتاد والأزرق أبرد — وبه تُقاس ظاهرتا النينيو والنينيا.',
    'layerGroup.sst-anomaly': 'حرارة المحيطات',
    'layerVariant.wind': 'سرعة الرياح',
    'layerVariant.wind-gusts': 'هبّات الرياح',
    'layerVariant.temperature': 'فعلي',
    'layerVariant.feels-like': 'الإحساس الحراري',
    'layerVariant.wet-bulb': 'اللمبة الرطبة',
    'layerVariant.k-index': 'K-Index (قابلية)',
    'layerVariant.o-index': 'عواصف رعدية',
    'layerVariant.humidity': 'النسبية',
    'layerVariant.dewpoint': 'نقطة الندى',

    // وصف كل طبقة (لوحة الحالة/التلميحات)
    'layerDesc.wind': 'خريطة سرعة الرياح مع جسيمات متحركة فوقها لقراءة الاتجاه والحركة.',
    'layerDesc.wind-gusts': 'أعلى سرعة رياح متوقعة في الهبّات، مفيدة لتمييز مناطق الخطر عن سرعة الرياح المتوسطة.',
    'layerDesc.radar-sim': 'انعكاسية الرادار كما يحاكيها نموذج GFS لكل ساعة قادمة في العالم كلّه — توقّع لا رصد، وبنفس ألوان رادار الأمطار.',
    'layerDesc.precipitation': 'مصدر المطر والثلج هو النموذج المحدّد أعلى الخريطة؛ تُصنّف الجسيمات ثلجاً عندما تكون حرارة النموذج منخفضة.',
    'layerDesc.temperature': 'درجة الحرارة عند ارتفاع مترين فوق السطح.',
    'layerDesc.feels-like': 'درجة الحرارة المحسوسة بعد تأثير الرطوبة والرياح.',
    'layerDesc.wet-bulb': 'درجة حرارة اللمبة الرطبة — مؤشّر إجهاد حراري؛ تجاوز ~31°م خطير و~35°م حدّ بقاء الإنسان.',
    'layerDesc.k-index': 'مؤشر احتمالية العواصف الرعدية من عدم الاستقرار والرطوبة في الطبقات المتوسطة؛ القيم الأعلى تعني بيئة أنسب للعواصف.',
    'layerDesc.o-index': 'طاقة عدم الاستقرار الحملي المتاحة (CAPE) من النموذج المختار — نفس الحقل الذي تعرضه طبقة "Thunder" في Windy؛ القيم الأعلى تعني بيئة أنسب لعواصف رعدية أقوى.',
    'layerDesc.pressure': 'ضغط السطح من النموذج، وتمهيد لاحق لخطوط الضغط.',
    'layerDesc.humidity': 'الرطوبة النسبية عند ارتفاع مترين.',
    'layerDesc.dewpoint': 'طبقة مستقلّة لفهم الرطوبة الفعلية لا النسبة فقط.',
    'layerDesc.clouds': 'تغطية سحابية متوقعة من النموذج.',
    'layerDesc.radar': 'أمطار مرصودة شبه حيّة، وليست توقعات النموذج.',
    'layerDesc.satellite': 'صور أقمار صناعية مجانية عبر WMTS، وقد تتأخر عن الزمن الحقيقي.',
    'layerDesc.hurricanes': 'متتبّع أنظمة مدارية، ويحتاج مصدراً رسمياً لاحقاً للإنتاج.',
    'layerDesc.wildfires': 'نقاط ساخنة من FIRMS، تحتاج مفتاحاً مجانياً للإنتاج.',

    // ── لوحة الطبقات ────────────────────────────────────────────────────
    'layers.title': 'خرائط الطقس',
    'layers.open': 'فتح الطبقات',
    'layers.close': 'إغلاق الطبقات',
    'layers.sidebarTitle': 'الطبقات',
    'layers.sectionObservation': 'الأقمار الصناعية والرادار',
    'layers.sectionWeather': 'عناصر الطقس',
    'layers.sectionOverlays': 'تراكبات فوق الخريطة',
    'layers.forecastGroup': 'طبقات التوقعات',
    'layers.tileGroup': 'الرادار والقمر الصناعي',
    'layers.modelPending': 'طبقات هذا النموذج قيد التحضير.',
    'layers.modelPendingLong': 'طبقات هذا النموذج قيد التحضير على الخادم — اختر نموذجاً آخر مؤقّتاً.',

    // ── الأزرار العائمة ─────────────────────────────────────────────────
    'toggle.particles.show': 'إظهار جسيمات الرياح',
    'toggle.particles.hide': 'إخفاء جسيمات الرياح',
    'toggle.particles.label': 'جسيمات الرياح',
    'toggle.isobars.show': 'إظهار خطوط تساوي الضغط',
    'toggle.isobars.hide': 'إخفاء خطوط تساوي الضغط',
    'toggle.isobars.label': 'خطوط الضغط',
    // الطبقة **توقّعات** لا رصد لحظي (تُشتقّ من K-index + الهطول المتوقَّع — راجع
    // LightningLayer.tsx): التسمية القديمة «البروق الحيّة» توهم برصدٍ حقيقي، وأي مهتمّ
    // بالأرصاد يميّز بين forecast وobservation فوراً ويفقد الثقة بالموقع كلّه لأجلها.
    'toggle.lightning.show': 'إظهار توقّع البرق مع الأمطار',
    'toggle.lightning.hide': 'إخفاء توقّع البرق',
    'toggle.lightning.label': 'توقّع البرق',
    'toggle.hurricanes.show': 'إظهار الأعاصير',
    'toggle.hurricanes.hide': 'إخفاء الأعاصير',
    'cyclone.tropicalStorm': 'عاصفة مدارية',
    'cyclone.category': 'فئة {n}',
    'cyclone.wind': 'سرعة الرياح',
    'cyclone.pressure': 'الضغط المركزي',
    'cyclone.direction': 'الاتجاه',
    'cyclone.movement': 'سرعة الحركة',
    'cyclone.track': 'المسار المتوقّع',
    'cyclone.now': 'الآن',
    'cyclone.colDate': 'التاريخ',
    'cyclone.colTime': 'الوقت',
    'cyclone.colCat': 'الفئة',
    'cyclone.colWind': 'الرياح',
    'cyclone.colPressure': 'الضغط',
    'cyclone.forecastMark': 'تنبّؤ',
    'cyclone.source': 'المصدر',
    'attrib.title': 'مصادر البيانات',
    'attrib.short': 'المصادر',
    'attrib.basemap': 'خريطة الأساس',
    'attrib.gfs': 'نموذج GFS',
    'attrib.ecmwf': 'نموذج ECMWF',
    'attrib.icon': 'نموذج ICON',
    'attrib.satellite': 'صور الأقمار',
    'attrib.meteosat': 'صور Meteosat',
    'attrib.radar': 'الرادار المرصود',
    'attrib.lightning': 'البروق المرصودة',
    'attrib.cyclones': 'الأعاصير',
    'attrib.wildfires': 'الحرائق',
    'attrib.point': 'توقّعات النقطة',
    'attrib.places': 'أسماء الأماكن',
    'cyclone.hoursAhead': '+{n} س',
    'cyclone.close': 'إغلاق',
    'cyclone.activeSystems': 'أنظمة نشطة',
    'cyclone.legend': 'دليل الرموز',
    'cyclone.tabTracking': 'التتبّع',
    'cyclone.displayOptions': 'خيارات العرض',
    'cyclone.showSystems': 'الأنظمة',
    'cyclone.showDisturbances': 'مناطق التطوّر',
    'cyclone.showPast': 'الماضي',
    'cyclone.showCurrent': 'الحاضر',
    'cyclone.showFuture': 'المستقبل',
    'cyclone.pointStyle': 'شكل نقاط المسار',
    'cyclone.pointStyleCyclone': 'رموز الأعاصير',
    'cyclone.pointStyleDot': 'نقاط بسيطة',
    'overlay.crosshair': 'علامة التصويب',
    'overlay.labels': 'المناطق',
    'overlay.alerts': 'تحذيرات الأرصاد (أمريكا)',
    'overlay.labelValues': 'قيم المناطق',
    'cyclone.disturbances': 'اضطرابات مدارية',
    'cyclone.developmentArea': 'منطقة التطوّر المحتملة',
    'cyclone.prob2day': 'خلال يومين: {n}%',
    'cyclone.prob7day': 'خلال 7 أيام: {n}%',
    'cyclone.distArea': 'منطقة {basin} {n}',
    'cyclone.distProb': 'احتمال التكوّن: {p2}% خلال يومين · {p7}% خلال 7 أيام',
    'cyclone.basin.Atlantic': 'الأطلسي',
    'cyclone.basin.Pacific': 'الهادئ',
    'cyclone.tabLegend': 'دليل الرموز',
    'cyclone.legendStrength': 'درجات الشدّة',
    'cyclone.level.cat-5': 'إعصار فئة 5',
    'cyclone.level.cat-4': 'إعصار فئة 4',
    'cyclone.level.cat-3': 'إعصار فئة 3',
    'cyclone.level.cat-2': 'إعصار فئة 2',
    'cyclone.level.cat-1': 'إعصار فئة 1',
    'cyclone.level.storm': 'عاصفة مدارية',
    'cyclone.level.depression': 'منخفض مداري',
    'cyclone.level.post': 'ما بعد مداري',
    'cyclone.level.remnant': 'بقايا منخفض',
    'cyclone.level.disturbance': 'اضطراب مداري',
    'cyclone.legendColors': 'الألوان',
    'cyclone.legendYellow': 'عاصفة مدارية والفئتان 1–2',
    'cyclone.legendRed': 'الفئة 3 فأعلى (إعصار كبير)',
    'cyclone.legendSymbols': 'رموز المسار',
    'cyclone.legendSolid': 'خطّ مصمت — مسار منقضٍ',
    'cyclone.legendDashed': 'خطّ متقطّع — مسار متوقّع',
    'cyclone.legendCone': 'دائرة شفّافة — مخروط عدم اليقين',
    'cyclone.legendDots': 'أيقونات صغيرة — مواضع زمنية على المسار',
    'cyclone.compass.N': 'شمال',
    'cyclone.compass.NE': 'شمال شرق',
    'cyclone.compass.E': 'شرق',
    'cyclone.compass.SE': 'جنوب شرق',
    'cyclone.compass.S': 'جنوب',
    'cyclone.compass.SW': 'جنوب غرب',
    'cyclone.compass.W': 'غرب',
    'cyclone.compass.NW': 'شمال غرب',
    'toggle.wildfires.show': 'إظهار الحرائق',
    'toggle.wildfires.hide': 'إخفاء الحرائق',

    // ── شريط الأدوات الأيمن ─────────────────────────────────────────────
    'toolbar.search': 'بحث',
    'toolbar.myLocation': 'موقعي',
    'toolbar.zoomIn': 'تكبير',
    'toolbar.zoomOut': 'تصغير',
    'toolbar.fullscreen': 'ملء الشاشة',
    'toolbar.share': 'مشاركة',
    'toolbar.info': 'معلومات',
    'toolbar.measure': 'قياس',
    'toolbar.more': 'أدوات أخرى',
    'measure.stop': 'إنهاء القياس',

    // ── أدوات القياس (مسافة/مساحة) ──────────────────────────────────────
    'measure.distanceTitle': 'قياس المسافة',
    'measure.areaTitle': 'قياس المساحة',
    'measure.distance': 'المسافة',
    'measure.area': 'المساحة',
    'measure.hint': 'انقر على الخريطة لإضافة نقاط. انقر نقراً مزدوجاً للإنهاء.',
    'measure.undo': 'تراجع',
    'measure.clear': 'مسح',
    'search.placeholder': 'ابحث عن مدينة…',
    'search.close': 'إغلاق البحث',
    'search.loading': 'جارٍ البحث…',
    'search.hint': 'اكتب اسم مدينة للبحث',
    'search.empty': 'لا توجد نتائج',
    'geo.unsupported': 'المتصفح لا يدعم تحديد الموقع',
    'geo.failed': 'تعذّر تحديد موقعك',
    'location.none': 'لم يتم تحديد موقع',

    // نافذة "عن التطبيق"
    'about.title': 'عن Sky Radar',
    'about.cityTitle': 'طقس المدن',
    'about.cityLink': 'تصفّح طقس المدن حول العالم',
    'about.whatTitle': 'ما هذا التطبيق؟',
    'about.whatBody': 'منصّة تفاعلية لعرض الطقس حول العالم في الوقت الحقيقي.',
    'about.sourcesTitle': 'مصادر البيانات',
    'about.sourceGfs': 'الوكالة الأمريكية NOAA (بيانات حكومية مفتوحة)',
    'about.sourceEcmwf': 'المركز الأوروبي (Open Data)',
    'about.sourceRainviewer': 'رادار المطر المرصود',
    'about.sourceNasa': 'أقمار صناعية وحرائق',
    'about.mapTitle': 'الخريطة',
    'about.mapBody': 'OpenStreetMap © مع محرّك MapLibre GL JS',
    'about.updatedTitle': 'آخر تحديث',
    'about.followTitle': 'تابعنا',

    'social.facebook': 'فيسبوك',
    'social.x': 'X',
    'social.instagram': 'إنستغرام',
    'social.tiktok': 'تيك توك',
    'social.threads': 'ثريدز',

    'report.title': 'الإبلاغ عن مشكلة',
    'report.hint': 'أفضل طريقة لوصف المشكلة هي أن ترسل لنا لقطات شاشة أو فيديو، مع وصف موجز لها وكيفية إعادة إنتاجها.',
    'report.placeholder': 'صف المشكلة التي واجهتها…',
    'report.attach': 'إرفاق لقطة شاشة أو فيديو',
    'report.attachmentTooLarge': 'حجم الملف كبير جداً — الحدّ الأقصى 10 ميجابايت.',
    'report.submit': 'أرسل لنا تقريراً عن الخطأ',
    'report.submitFailed': 'تعذّر إرسال البلاغ — تحقّق من اتصالك وحاول مجدداً.',
    'report.thanks': 'وصلنا بلاغك — شكراً لمساعدتنا على تحسين Sky Radar.',

    // نافذة المشاركة
    'share.title': 'مشاركة الموقع',
    'share.text': 'تابع حالة الطقس على Sky Radar',
    'share.whatsapp': 'واتساب',
    'share.telegram': 'تيليجرام',
    'share.facebook': 'فيسبوك',
    'share.email': 'البريد',
    'share.copyLink': 'نسخ الرابط',
    'share.copy': 'نسخ',
    'share.copied': 'تم النسخ',

    // ── لوحة الإعدادات ──────────────────────────────────────────────────
    'settings.title': 'الإعدادات',
    'settings.close': 'إغلاق الإعدادات',
    'settings.units.title': 'وحدات القياس',
    'settings.units.temperature': 'الحرارة',
    'settings.units.celsius': '°مئوية',
    'settings.units.fahrenheit': '°فهرنهايت',
    'settings.units.wind': 'الرياح',
    'settings.units.kmh': 'كم/س',
    'settings.units.mph': 'ميل/س',
    'settings.units.ms': 'م/ث',
    'settings.units.knots': 'عقدة',
    'settings.units.pressure': 'الضغط',
    'settings.units.hpa': 'هكتوباسكال',
    'settings.units.inhg': 'إنش زئبق',
    'settings.units.precipitation': 'الأمطار',
    'settings.units.mm': 'ملم',
    'settings.units.inch': 'إنش',
    'settings.about.title': 'حول التطبيق',
    'settings.about.tagline': 'منصّة عرض حيّة للطقس حول العالم',
    'settings.about.version': 'الإصدار {v}',
    'settings.about.data': 'البيانات',
    'settings.language.title': 'لغة الواجهة',

    // ── النماذج ────────────────────────────────────────────────────────
    'model.title': 'النموذج الجوي',
    'model.tooltip': 'النموذج: {name} ({resolution})',
    'model.provider.GFS': 'الوكالة الأمريكية NOAA',
    'model.provider.ECMWF': 'المركز الأوروبي ECMWF',
    'model.provider.ICON': 'الهيئة الألمانية DWD',
    'model.resolution': '{km} كم',
    'settings.model.title': 'نموذج التنبؤ',
    'settings.model.cycle': 'دورة النموذج',
    'settings.model.age': 'عمر البيانات',
    'settings.model.generated': 'آخر توليد',
    'settings.model.next': 'التحديث القادم',
    'settings.model.ago': 'منذ {d}',
    'settings.model.in': 'خلال {d}',
    'settings.model.due': 'متوقّع الآن',
    'settings.model.unavailable': 'لا توجد بيانات مولَّدة لهذا النموذج بعد.',
    'settings.model.note': 'موعد التحديث تقديري، محسوب من زمن نشر الدورة السابقة.',
    'settings.model.staleNote': 'البيانات متقادمة — يبدو أن توليدها على الخادم متوقّف.',

    // اختصارات مدد زمنية (منذ 3س 20د)
    'duration.d': 'ي',
    'duration.h': 'س',
    'duration.m': 'د',
    'duration.s': 'ث',

    // ── مؤشّر التحميل ───────────────────────────────────────────────────
    'loading.model': 'جارٍ تحميل نموذج {name}',
    'loading.layer': 'جارٍ تحميل {name}',
    'loading.layerShort.wind': 'الرياح',
    'loading.layerShort.wind-gusts': 'هبّات الرياح',
    'loading.layerShort.radar-sim': 'الرادار المتوقَّع',
    'loading.layerShort.precipitation': 'الأمطار',
    'loading.layerShort.temperature': 'الحرارة',
    'loading.layerShort.feels-like': 'الإحساس الحراري',
    'loading.layerShort.wet-bulb': 'اللمبة الرطبة',
    'loading.layerShort.k-index': 'K-Index',
    'loading.layerShort.o-index': 'عواصف رعدية',
    'loading.layerShort.pressure': 'الضغط',
    'loading.layerShort.humidity': 'الرطوبة',
    'loading.layerShort.dewpoint': 'نقطة الندى',
    'loading.layerShort.clouds': 'الغيوم',
    // كانت هذه السبعة ناقصة، فيُظهر مؤشّر التحميل مفتاح الترجمة نفسه للزائر
    // («‏loading.layerShort.sst-anomaly»). العائلة مفهرسة بمعرّف الطبقة، فكل معرّف في
    // `layer.*` يلزمه نظيرٌ هنا — وإلّا انكشف المفتاح عند أوّل تحميل لتلك الطبقة.
    'loading.layerShort.radar': 'الرادار',
    'loading.layerShort.satellite': 'القمر الصناعي',
    'loading.layerShort.hurricanes': 'الأعاصير',
    'loading.layerShort.wildfires': 'الحرائق',
    'loading.layerShort.t850-anomaly': 'شذوذ حرارة 850',
    'loading.layerShort.sst-anomaly': 'حرارة المحيطات',
    'loading.layerShort.sst-anomaly-rel': 'حرارة المحيطات — نسبي',

    // ── مفتاح الألوان ──────────────────────────────────────────────────
    'legend.wind': 'سرعة الرياح ({unit})',
    'legend.wind-gusts': 'هبّات الرياح ({unit})',
    'legend.radar-sim': 'رادار متوقَّع — نموذج GFS ({unit})',
    'legend.temperature': 'درجة الحرارة ({unit})',
    'legend.feels-like': 'الإحساس الحراري ({unit})',
    'legend.wet-bulb': 'اللمبة الرطبة ({unit})',
    'legend.dewpoint': 'نقطة الندى ({unit})',
    'legend.k-index': 'K-Index — مؤشر العواصف الرعدية',
    'legend.o-index': 'عواصف رعدية — طاقة عدم الاستقرار الحملي (CAPE)',
    'legend.precipitation': 'الأمطار (تراكم 3 ساعات، {unit})',
    'legend.pressure': 'الضغط الجوي ({unit})',
    'legend.humidity': 'الرطوبة النسبية (%)',
    'legend.clouds': 'الغطاء السحابي (%)',
    'radar.intensity.trace': 'رذاذ خفيف',
    'radar.intensity.light': 'أمطار خفيفة',
    'radar.intensity.moderate': 'أمطار معتدلة',
    'radar.intensity.heavy': 'أمطار غزيرة',
    'radar.intensity.violent': 'أمطار غزيرة جدّاً',
    'radar.intensity.hail': 'عاصفة — بَرَد محتمل',
    'overlay.aerial': 'خلفية صور جوّية',
    'overlay.radarCoverage': 'نطاق تغطية الرادار',
    'overlay.lightningSound': 'صوت الرعد',
    'overlay.timestamp': 'ختم الوقت والتاريخ',
    'stamp.updated': 'آخر تحديث',
    'legend.radar': 'شدّة الرادار ({unit})',
    'legend.t850Anomaly': 'شذوذ حرارة 850 هكتوباسكال ({unit}) — مقارنةً بمعدّل 1981–2010',
    'legend.sstAnomaly': 'شذوذ حرارة سطح البحر ({unit}) — مقارنةً بمعدّل 1971–2000',
    'unit.celsius': '°م',
    'unit.fahrenheit': '°ف',
    'unit.kmh': 'كم/س',
    'unit.mm': 'مم',
    'unit.inch': 'إنش',
    'unit.hpa': 'hPa',
    'unit.inhg': 'inHg',
    'unit.km': 'كم',

    // ── التلميح / الهطول ────────────────────────────────────────────────
    'precip.none': 'لا هطول',
    'precip.drizzle': 'رذاذ خفيف',
    'precip.light': 'أمطار خفيفة',
    'precip.moderate': 'أمطار معتدلة',
    'precip.heavy': 'أمطار غزيرة',
    'precip.extreme': 'أمطار شديدة',
    'precip.accum3h': 'الأمطار (3h)',
    'snow.flurries': 'زخّات ثلج خفيفة',
    'snow.light': 'ثلوج خفيفة',
    'snow.moderate': 'ثلوج معتدلة',
    'snow.heavy': 'ثلوج غزيرة',
    'snow.extreme': 'ثلوج كثيفة',
    'snow.accum3h': 'الثلوج (3h)',

    // جهات الرياح الستّ عشرة
    'compass.N': 'شمال', 'compass.NNE': 'شمال/ش‌ش', 'compass.NE': 'شمال شرقي',
    'compass.ENE': 'شرق/ش‌ش', 'compass.E': 'شرقي', 'compass.ESE': 'شرق/ج‌ش',
    'compass.SE': 'جنوب شرقي', 'compass.SSE': 'جنوب/ج‌ش', 'compass.S': 'جنوبي',
    'compass.SSW': 'جنوب/ج‌غ', 'compass.SW': 'جنوب غربي', 'compass.WSW': 'غرب/ج‌غ',
    'compass.W': 'غربي', 'compass.WNW': 'غرب/ش‌غ', 'compass.NW': 'شمال غربي',
    'compass.NNW': 'شمال/ش‌غ',

    // ── شريط الوقت ─────────────────────────────────────────────────────
    'time.today': 'اليوم',
    'time.tomorrow': 'غداً',
    'time.am': 'صباحاً',
    'time.pm': 'مساءً',
    'time.jumpLatest': 'الانتقال لآخر إطار',
    'time.frameReady': 'جاهز — انتقال فوري',
    'time.nowcast': 'توقّع',
    'time.frameLoading': 'غير محمَّى — قد ينتظر التحميل',
    'time.play': 'تشغيل الحركة',
    'time.pause': 'إيقاف الحركة',
    'month.1': 'يناير', 'month.2': 'فبراير', 'month.3': 'مارس', 'month.4': 'أبريل',
    'month.5': 'مايو', 'month.6': 'يونيو', 'month.7': 'يوليو', 'month.8': 'أغسطس',
    'month.9': 'سبتمبر', 'month.10': 'أكتوبر', 'month.11': 'نوفمبر', 'month.12': 'ديسمبر',
    // العربية لا تختصر أسماء الأشهر عرفاً، فالمختصر هو الاسم نفسه — يبقى المفتاح
    // موجوداً كي يستدعيه الكود بلا تفريع لغوي.
    'monthShort.1': 'يناير', 'monthShort.2': 'فبراير', 'monthShort.3': 'مارس', 'monthShort.4': 'أبريل',
    'monthShort.5': 'مايو', 'monthShort.6': 'يونيو', 'monthShort.7': 'يوليو', 'monthShort.8': 'أغسطس',
    'monthShort.9': 'سبتمبر', 'monthShort.10': 'أكتوبر', 'monthShort.11': 'نوفمبر', 'monthShort.12': 'ديسمبر',
    'day.0': 'الأحد', 'day.1': 'الاثنين', 'day.2': 'الثلاثاء', 'day.3': 'الأربعاء',
    'day.4': 'الخميس', 'day.5': 'الجمعة', 'day.6': 'السبت',

    // ── لوحة معلومات الطقس ─────────────────────────────────────────────
    'weather.selectedLocation': 'الموقع المحدد',
    'weather.hourly': 'توقعات كل ساعة',
    'weather.fetching': 'جاري جلب بيانات الطقس…',
    'weather.fetchFailed': 'تعذّر جلب بيانات الطقس لهذا الموقع.',
    'weather.updating': 'جاري التحديث…',
    'weather.feelsLike': 'إحساس {v}',
    'weather.cached': 'يتم عرض نسخة محفوظة مؤقتاً من آخر بيانات متاحة.',
    'weather.colTemp': 'حرارة',
    'weather.colPrecip': 'أمطار',
    'weather.colState': 'حالة',
    'weather.colHour': 'الساعة',
    'weather.openDetails': 'عرض تفاصيل الطقس لهذا الموقع',
    // اختصارات الإحداثيات: حرف واحد لكل جهة كما في «24° 42' ش، 46° 40' ق».
    'coord.N': 'ش', 'coord.S': 'ج', 'coord.E': 'ق', 'coord.W': 'غ',

    // حالات الطقس (وصف الرمز القادم من الخدمة)
    'wx.Clear sky': 'سماء صافية',
    'wx.Mainly clear': 'صافية في الغالب',
    'wx.Partly cloudy': 'غائم جزئياً',
    'wx.Overcast': 'غائم كلياً',
    'wx.Fog': 'ضباب',
    'wx.Rime fog': 'ضباب متجمّد',
    'wx.Light drizzle': 'رذاذ خفيف',
    'wx.Moderate drizzle': 'رذاذ متوسط',
    'wx.Dense drizzle': 'رذاذ كثيف',
    'wx.Light rain': 'مطر خفيف',
    'wx.Moderate rain': 'مطر متوسط',
    'wx.Heavy rain': 'مطر غزير',
    'wx.Light showers': 'زخّات خفيفة',
    'wx.Moderate showers': 'زخّات متوسطة',
    'wx.Heavy showers': 'زخّات غزيرة',
    'wx.Light snow': 'ثلج خفيف',
    'wx.Moderate snow': 'ثلج متوسط',
    'wx.Heavy snow': 'ثلج كثيف',
    'wx.Snow grains': 'حبيبات ثلجية',
    'wx.Light snow showers': 'زخّات ثلج خفيفة',
    'wx.Heavy snow showers': 'زخّات ثلج غزيرة',
    'wx.Freezing drizzle': 'رذاذ متجمّد',
    'wx.Freezing rain': 'مطر متجمّد',
    'wx.Thunderstorm': 'عاصفة رعدية',
    'wx.Thunderstorm + hail': 'عاصفة مع بَرَد',
    'wx.Unknown': 'غير محدّد',

    // ── تعذّر تشغيل الخريطة (WebGL) ──────────────────────────────────────
    'webgl.title': 'تعذّر تشغيل الخريطة',
    'webgl.body': 'يحتاج عرض الخريطة إلى WebGL، ومتصفّحك لا يوفّره حالياً — غالباً لأن التسريع العتادي مُطفأ أو أن تعريف كرت الشاشة محجوب.',
    'webgl.fixEnable': 'فعّل «استخدام تسريع الرسوميات عند توفّره» من إعدادات المتصفّح (النظام) ثم أعد تشغيله.',
    'webgl.fixUpdate': 'حدّث تعريف كرت الشاشة، أو أعد تشغيل الجهاز بعد التحديث.',
    'webgl.fixBrowser': 'جرّب متصفّحاً آخر حديثاً (Chrome أو Edge أو Firefox).',
    'webgl.reload': 'إعادة المحاولة',

    // ── لوحة الأدمن ────────────────────────────────────────────────────
    'admin.nav.overview': 'نظرة عامة',
    'admin.nav.layers': 'الطبقات والألوان',
    'admin.nav.models': 'النماذج الجوية',
    'admin.nav.reports': 'بلاغات المشاكل',
    'admin.nav.particles': 'جسيمات الرياح',
    'admin.nav.viewMap': 'عرض الخريطة',
    'admin.badge': 'أدمن',
    'admin.header.title': 'لوحة تحكّم Sky Radar',
    'admin.header.menu': 'القائمة',
    'admin.logout': 'خروج',
    'admin.login.subtitle': 'تسجيل دخول الأدمن',
    'admin.layers.enabledCount': '{on} مفعّلة من {total}',
    'admin.layers.colorHelp': 'يُستخدم للأيقونة والتعريف السريع داخل لوحة التحكم.',
    'admin.layers.gradientHelp': 'يوضّح معنى الألوان فوق الخريطة، مثل أمطار خفيفة إلى شديدة.',
    'admin.layers.opacityOrderHelp': 'تحدّد وضوح الطبقة ومكانها فوق أو تحت الطبقات الأخرى.',
    'admin.layers.edit': 'تعديل',
    'admin.layers.toastEnabled': 'فُعّلت طبقة «{name}»',
    'admin.layers.toastDisabled': 'أُخفيت طبقة «{name}»',
    'admin.models.edit': 'تعديل {name}',
    'admin.models.providerPlaceholder': 'الوكالة الأمريكية NOAA',
    'admin.models.resolutionPlaceholder': '22 كم',
    'admin.models.toastEnabled': 'فُعّل نموذج {name}',
    'admin.models.toastDisabled': 'أُخفي نموذج {name}',
    'admin.models.deleted': 'حُذف نموذج {name}.',
    'admin.models.deleteConfirm': 'سيُحذف نموذج «{name}» من الإعدادات (لن تُحذف ملفات rasters). متابعة؟',
    'admin.gradient.count': '{n} نقاط لون',
    'admin.gradient.addStop': 'إضافة نقطة',
    'admin.error.unexpected': 'حدث خطأ غير متوقع.',
    'admin.login.email': 'البريد الإلكتروني',
    'admin.login.password': 'كلمة المرور',
    'admin.login.submit': 'دخول',
    'admin.login.submitting': 'جارِ الدخول…',

    'admin.dash.visitsWindow': 'الزيارات ({window})',
    'admin.dash.today': 'اليوم: {n}',
    'admin.dash.goLayers': 'الانتقال إلى الطبقات ←',
    'admin.dash.goModels': 'الانتقال إلى النماذج ←',
    'admin.dash.range7': '٧ أيام',
    'admin.dash.range30': '٣٠ يوم',
    'admin.dash.range90': '٩٠ يوم',
    'admin.dash.noData': 'لا بيانات بعد',
    'admin.dash.homePage': 'الصفحة الرئيسية',
    'admin.dash.trackingMissing': 'لم يُنشر تتبّع الزوّار بعد — نفّذ الهجرة على الخادم.',
    'admin.dash.visitorsFailed': 'تعذّر جلب بيانات الزوّار',
    'admin.dash.newUsers': 'مستخدمون جدد',
    'admin.dash.enabledLayers': 'الطبقات المفعّلة',
    'admin.dash.enabledModels': 'النماذج المفعّلة',
    'admin.dash.lastEdit': 'آخر تعديل',
    'admin.dash.visits': 'الزيارات',
    'admin.dash.visitorRate': 'معدّل الزوّار',
    'admin.dash.newUsersChart': 'المستخدمون الجدد',
    'admin.dash.topCountries': 'أعلى الدول وصولاً',
    'admin.dash.topReferrers': 'أعلى مصادر الزيارات',
    'admin.dash.topPages': 'أعلى الصفحات زيارة',
    'admin.dash.topDevices': 'أعلى الأجهزة',
    'admin.dash.topOs': 'أنظمة التشغيل',
    'admin.dash.topBrowsers': 'المتصفّحات',
    'admin.dash.manageLayers': 'إدارة الطبقات',
    'admin.dash.manageModels': 'إدارة النماذج',

    'admin.layers.title': 'الطبقات والألوان',
    'admin.layers.colColor': 'لون الطبقة',
    'admin.layers.colGradient': 'تدرّج الخريطة',
    'admin.layers.colOpacityOrder': 'الشفافية والترتيب',
    'admin.layers.colorTitle': 'لون تعريف الطبقة',
    'admin.layers.opacityTitle': 'شفافية الطبقة فوق الخريطة',
    'admin.layers.moveUp': 'أعلى',
    'admin.layers.moveDown': 'أسفل',
    'admin.layers.group.satellite': 'قمر اصطناعي',
    'admin.layers.group.radar': 'رادار',
    'admin.layers.group.precipitation': 'الأمطار',
    'admin.layers.group.wind': 'الرياح',
    'admin.layers.group.temperature': 'الحرارة',
    'admin.layers.group.storms': 'العواصف',
    'admin.layers.group.humidity': 'الرطوبة',
    'admin.layers.group.pressure': 'الضغط',
    'admin.layers.group.extra': 'إضافية',
    'admin.layers.group.sst-anomaly': 'حرارة المحيطات',
    'admin.layers.group.t850-anomaly': 'شذوذ حرارة 850 hPa',
    'admin.layers.group.radar-sim': 'الرادار المتوقَّع',
    'admin.layers.group.clouds': 'الغيوم',
    'admin.layers.group.overlay': 'تراكبات',

    'admin.layerEdit.back': 'رجوع',
    'admin.layerEdit.saved': 'حُفظت التغييرات — حدّث صفحة الخريطة لرؤيتها.',
    'admin.layerEdit.restored': 'استُعيدت الإعدادات الافتراضية.',
    'admin.layerEdit.restoreDefaults': 'استعادة الافتراضي',
    'admin.layerEdit.restore': 'استعادة',
    'admin.layerEdit.templateApplied': 'فُعِّل قالب «{label}» — حدّث صفحة الخريطة لرؤيته.',
    'admin.layerEdit.templateActive': 'مُفعَّل',
    'admin.layerEdit.confirmResetLayer': 'ستُستبدل كل تخصيصات طبقة «{name}» (الأسماء والألوان والتدرّج) بالقيم الافتراضية. متابعة؟',
    'admin.layerEdit.save': 'حفظ التغييرات',
    'admin.layerEdit.saving': 'جارِ الحفظ…',
    'admin.layerEdit.basics': 'الإعدادات الأساسية',
    'admin.layerEdit.nameAr': 'الاسم بالعربية',
    'admin.layerEdit.nameEn': 'الاسم بالإنجليزية',
    'admin.layerEdit.accentColor': 'لون الأيقونة/التمييز',
    'admin.layerEdit.icon': 'الأيقونة',
    'admin.layerEdit.enabled': 'الطبقة مفعّلة',
    'admin.layerEdit.disabled': 'الطبقة مخفيّة من الخريطة',
    'admin.layerEdit.enabling': 'جارِ التفعيل…',
    'admin.layerEdit.palette': 'قالب الألوان',
    'admin.layerEdit.gradient': 'تدرّج ألوان الخريطة',
    'admin.layerEdit.legend': 'شريط المفتاح (Legend)',
    'admin.layerEdit.legendTitle': 'العنوان',
    'admin.layerEdit.legendLabels': 'التسميات (مفصولة بفواصل)',
    'admin.gradient.preview': 'معاينة التدرّج على الخريطة',
    'admin.gradient.stop': 'نقطة لون',
    'admin.gradient.removeStop': 'حذف النقطة',
    'admin.gradient.value': 'القيمة',
    'admin.gradient.color': 'اللون',
    'admin.gradient.opacity': 'الشفافية',

    'admin.models.title': 'النماذج الجوية',
    'admin.models.add': 'إضافة نموذج',
    'admin.models.saved': 'حُفظ النموذج.',
    'admin.models.key': 'المعرّف (key)',
    'admin.models.name': 'الاسم المعروض',
    'admin.models.provider': 'المزوّد',
    'admin.models.resolution': 'الدقة',
    'admin.models.color': 'اللون',
    'admin.models.enabled': 'مفعّل',
    'admin.models.delete': 'حذف',
    'admin.models.deleteTitle': 'حذف النموذج',

    'admin.particles.title': 'القيم الافتراضية لجسيمات الرياح',
    'admin.particles.section': 'حركة الجسيمات',
    'admin.particles.color': 'لون الجسيمات',
    'admin.particles.saved': 'حُفظت القيم الافتراضية',
    'admin.particles.restoreConfirm': 'ستُستبدل كل قيم حركة الجسيمات الافتراضية بالقيم المعتمَدة أصلاً. متابعة؟',
    'admin.particles.count': 'عدد الخطوط (الكثافة)',
    'admin.particles.count.min': 'قليل',
    'admin.particles.count.max': 'كثيف جداً',
    'admin.particles.speed': 'تسارع الخطوط (السرعة)',
    'admin.particles.speed.min': 'منخفض',
    'admin.particles.speed.max': 'هام',
    'admin.particles.trail': 'طول الخطوط (الذيل)',
    'admin.particles.trail.min': 'قصير',
    'admin.particles.trail.max': 'طويل',
    'admin.particles.opacity': 'سطوع الجسيمات',
    'admin.particles.opacity.min': 'شفاف جداً',
    'admin.particles.opacity.max': 'غير شفاف',
    'admin.particles.width': 'متوسط سمك الخط',
    'admin.particles.width.min': 'نحيف',
    'admin.particles.width.max': 'واسع',
    'admin.particles.widthJitter': 'نثر سمك الخط',
    'admin.particles.widthJitter.min': 'نفس السمك',
    'admin.particles.widthJitter.max': 'سمك متنوع',
    'admin.particles.life': 'صلاحية الخطوط',
    'admin.particles.life.min': 'عابر',
    'admin.particles.life.max': 'مستمر',

    'admin.reports.title': 'بلاغات المشاكل',
    'admin.reports.empty': 'لا توجد بلاغات.',
    'admin.reports.total': '{n} بلاغ',
    'admin.reports.openBadge': '{n} بلاغ مفتوح',
    'admin.reports.status.open': 'مفتوح',
    'admin.reports.status.resolved': 'محلول',
    'admin.reports.pageUrl': 'الصفحة',
    'admin.reports.attachment': 'المرفق',
    'admin.reports.deleteTitle': 'حذف البلاغ',
    'admin.reports.deleteConfirm': 'سيُحذف البلاغ ومرفقه نهائياً. متابعة؟',
} as const;

/** شكل القاموس — en.ts ملزَم بتغطية كل مفتاح هنا (يفرضه المترجم). */
export type DictionaryKey = keyof typeof AR_DICTIONARY;
export type Dictionary = Record<DictionaryKey, string>;
